import { render, staticRenderFns } from "./UpgradePlanCardOne.vue?vue&type=template&id=3a2af1b0"
import script from "./UpgradePlanCardOne.vue?vue&type=script&lang=js"
export * from "./UpgradePlanCardOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports